export default {
  name: 'PcTable',
  data() {
    return {
      className: 'app__table',
    };
  },
};
